import { Component } from 'react';

import type { ReactNode } from 'react';

type ErrorBoundaryProps = {
	children: ReactNode | (() => ReactNode);
	errorElement?: ReactNode;
};

type ErrorBoundaryState = {
	hasError: boolean;
	error?: Error;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	state: ErrorBoundaryState = {
		hasError: false,
		error: undefined,
	};

	static getDerivedStateFromError(error: Error): ErrorBoundaryState {
		return { hasError: true, error };
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		// TO DO - Add analytics here
		console.info('ErrorBoundary caught an error', error, errorInfo);
	}

	render() {
		const { hasError } = this.state;
		const { errorElement, children } = this.props;

		if (hasError) {
			return errorElement ?? <></>;
		}

		if (typeof children === 'function') {
			return (children as () => ReactNode)();
		}

		return children;
	}
}
